import { render } from "./WelcomePage.vue?vue&type=template&id=c920136e&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=c920136e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c920136e"]])

export default __exports__